<div style='text-align:center'>
  <h1>Error al retornar datos</h1>

  <p>
    Hubo un error desconocido al momento de recibir los datos del pago,
    favor de comunicarse ingresando a https://aranceles.uv.cl, o
    también a través del email finanzas.recaudacion@uv.cl
    o al fono (032) 2507237 para indicar si el pago fué realizado
    por parte de su Banco.
  </p>

  <p *ngIf="parametros.err != null || parametros.err != undefined">
    Código de error: {{parametros.err}}
  </p>

  <div>

    <button pButton type="button" label="Volver" (click)="volver()" class="me-1 p-button-sm"></button>

  </div>
</div>